export const LevelUpEffect = ({ showLevelUp, levelUpData }) => {
  if (!showLevelUp || !levelUpData) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center pointer-events-none overflow-hidden">
      {/* Screen Flash */}
      <div
        className="absolute inset-0 animate-levelup-flash"
        style={{
          background: `linear-gradient(45deg, ${levelUpData.color1}, ${levelUpData.color2})`,
          mixBlendMode: 'screen'
        }}
      />

      {/* Shockwave Rings */}
      {[0, 0.2, 0.4, 0.6].map((delay, i) => (
        <div
          key={i}
          className="absolute top-1/2 left-1/2 animate-shockwave"
          style={{
            width: '200px',
            height: '200px',
            border: `4px solid ${levelUpData.color1}`,
            borderRadius: '50%',
            marginLeft: '-100px',
            marginTop: '-100px',
            animationDelay: `${delay}s`
          }}
        />
      ))}

      {/* Particle Burst - Angular Shapes */}
      <div className="absolute top-1/2 left-1/2">
        {[...Array(40)].map((_, i) => {
          const angle = (i / 40) * Math.PI * 2;
          const distance = 300 + Math.random() * 200;
          const tx = Math.cos(angle) * distance;
          const ty = Math.sin(angle) * distance;
          const rotation = Math.random() * 720 - 360;
          const shape = ['square', 'triangle', 'rectangle'][Math.floor(Math.random() * 3)];
          const color = [levelUpData.color1, levelUpData.color2, '#ffff00'][Math.floor(Math.random() * 3)];

          return (
            <div
              key={i}
              className="absolute animate-particle-burst"
              style={{
                '--tx': `${tx}px`,
                '--ty': `${ty}px`,
                '--r': `${rotation}deg`,
                animationDelay: `${Math.random() * 0.2}s`,
                left: 0,
                top: 0
              }}
            >
              {shape === 'square' && (
                <div className="w-3 h-3" style={{ backgroundColor: color }} />
              )}
              {shape === 'triangle' && (
                <div
                  style={{
                    width: 0,
                    height: 0,
                    borderLeft: '6px solid transparent',
                    borderRight: '6px solid transparent',
                    borderBottom: `12px solid ${color}`
                  }}
                />
              )}
              {shape === 'rectangle' && (
                <div className="w-4 h-2" style={{ backgroundColor: color }} />
              )}
            </div>
          );
        })}
      </div>

      {/* Giant Level Badge - Centered and Fixed */}
      <div className="relative w-full max-w-4xl px-4 animate-levelup-shake">
        <div className="animate-badge-zoom-fixed">
          <div
            className={`bg-gradient-to-r ${levelUpData.bg} border-4 sm:border-8 border-black px-6 sm:px-12 py-6 sm:py-8 shadow-2xl mx-auto relative`}
            style={{ filter: `drop-shadow(0 0 40px ${levelUpData.color1})` }}
          >
            <div className="text-center relative z-10">
              <div className="text-4xl sm:text-6xl md:text-8xl font-black mb-3 sm:mb-4 text-white animate-pulse">
                LEVEL UP!
              </div>
              <div className={`text-3xl sm:text-5xl md:text-7xl font-black ${levelUpData.color} uppercase tracking-wider mb-2 break-words`}>
                {levelUpData.title}
              </div>
              <div className="text-lg sm:text-2xl md:text-4xl font-black text-white/80">
                {levelUpData.message}
              </div>
            </div>

            {/* Glow effect behind badge */}
            <div
              className="absolute inset-0 blur-3xl opacity-70 -z-10"
              style={{
                background: `radial-gradient(circle, ${levelUpData.color1}, ${levelUpData.color2})`
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
